module.exports = __webpack_public_path__ + "img/061-sardinia.71880f96.svg";